const AdminCommunicationsTab = ({}) => {
	return <div> JE SUIS AdminCommunicationsTab</div>;
};
export default AdminCommunicationsTab;
